/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { Button } from "reactstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Timeout from "await-timeout";
import { handleErrors } from "../../../services/handleErrors";
import useFetcher from "../../../hooks/useFetcher";
import { fetchCasasCentrales } from "../../../services/casaCentralServices";
import { fetchRegiones } from "../../../services/regionServices";
import { fetchSucursales } from "../../../services/sucursalServices";
import { retriveRegionSucursalOptions } from "../../../utils/retriveRegionSucursalOptions";
import { LabSelect } from "../select";
import { InputTitle, Label } from "./styles";
import { createSectorGroup, updateSectorGroup } from "../../../services/labServices";

const createOrUpdateSectorGroup = async (data, id) => {
  if (id) {
    const { message } = await updateSectorGroup(id, data);
    toast.success(message);
    return true;
  }
  const { message } = await createSectorGroup(data);
  toast.success(message);
  return true;
};

const SectorGroupForm = ({ toggle, groupInfo, reload }) => {
  const [regiones, isLoadingRegiones] = useFetcher(fetchRegiones, undefined, "fetchRegiones");
  const [casasCentrales, isLoadingCasasCentrales] = useFetcher(fetchCasasCentrales, undefined, "fetchCasasCentrales");
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [regionValue, setRegionValue] = useState(groupInfo && groupInfo.labRelsSectorRegion ? groupInfo.labRelsSectorRegion.map((e) => e.itemId) : null);
  const [sucursalValue, setSucursalValue] = useState(groupInfo && groupInfo.labRelsSectorSucursal ? groupInfo.labRelsSectorSucursal.map((e) => e.itemId) : null);
  const [sucursalesOptions, setSucursalesOptions] = useState([]);

  // adapto el array de sucursales para mostrar elvalue en el react select
  const sucursalesToValue =
    sucursales && sucursales.length > 0
      ? sucursales.map((e) => {
          return { label: `${e.cc}  ${e.titulo}`, value: e.itemId };
        })
      : [];

  const ccToLab = true;
  //---------------------------------------------------------------------
  const helperRegionSucursal = retriveRegionSucursalOptions(
    regionValue,
    sucursalValue,
    regiones,
    sucursales,
    casasCentrales,
    isLoadingRegiones || isLoadingCasasCentrales || isLoadingSucursales,
    false,
    false,
    ccToLab
  );

  //---------------------------------------------------------------------

  useEffect(() => {
    // busca las sucursales correspondientes a las regiones seleccionadas
    if (regionValue) {
      const sucursalesSelected = regionValue.map((region) => {
        const helper = retriveRegionSucursalOptions(
          region,
          sucursalValue,
          regiones,
          sucursales,
          casasCentrales,
          isLoadingRegiones || isLoadingCasasCentrales || isLoadingSucursales,
          false,
          false,
          ccToLab
        );

        return helper.casasAndSucusOptions;
      });

      const unifiedArray = sucursalesSelected && sucursalesSelected.length > 0 ? [].concat(...sucursalesSelected) : [];
      if (unifiedArray.length > 0) {
        setSucursalesOptions(unifiedArray);
      }
    }

    if (regionValue && regionValue.length === 0) {
      setSucursalValue([]);
    }
  }, [regionValue, sucursales]);

  function getFunctionToFilter(filter, selected) {
    if (filter === "regiones") {
      const values = selected.map((e) => e.value);

      try {
        setRegionValue([...values]);
      } catch (error) {
        setRegionValue("");
      }
    }
    if (filter === "sucursal") {
      const values = selected.map((e) => e.value);
      try {
        setSucursalValue(values);
      } catch (error) {
        setSucursalValue("");
      }
    }
  }

  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const formik = useFormik({
    initialValues: {
      name: groupInfo ? groupInfo.name : "",
      regiones: [],
    },
    onSubmit: async (values) => {
      const dataToEdit = {
        ...values,
        regiones: regionValue && regionValue.length > 0 ? regionValue : [],
        sucursales: sucursalValue && sucursalValue.length > 0 ? sucursalValue : [],
      };

      if (!regionValue) {
        toast.error("Debe seleccionar al menos una region");
        return;
      }
      try {
        const res = await createOrUpdateSectorGroup(dataToEdit, groupInfo ? groupInfo.id : null);
        await Timeout.set(1000);
        toggle();
        reload();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Este campo es requerido."),
    }),
  });

  const regionError = () => {
    const error = { error: false };

    if (!regionValue) {
      error.regiones = "Debe seleccionar una region";
    }

    return error;
  };
  const messageError = regionError();

  return (
    <>
      <form className="theme-form" onSubmit={formik.handleSubmit}>
        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
          <div className="col-sm-9">
            <div className="form-group">
              <Label htmlFor="name" className="col-form-label pt-0 w-100" style={formik.errors.name && formik.touched.name ? { color: "red" } : null}>
                Nombre del grupo
                <InputTitle
                  name="name"
                  disabled={formik.isSubmitting}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  placeholder={formik.errors.name && formik.touched.name ? formik.errors.name : "Nombre del grupo"}
                  style={formik.errors.name && formik.touched.name ? { borderBottom: "1px solid red" } : null}
                />
              </Label>
            </div>
          </div>
          <div className="col-sm-9">
            <div className="form-group">
              <Label htmlFor="regiones" className="col-form-label pt-0 w-100" style={messageError.regiones && formik.touched.regiones ? { color: "red" } : null}>
                Region
                <LabSelect
                  isMulti
                  id="regiones"
                  name="regiones"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={helperRegionSucursal.regionesOptions.filter((option) => (regionValue ? JSON.stringify(regionValue).includes(option.value) : "")) || null}
                  placeholder="Seleccionar"
                  isClearable
                  isLoading={isLoadingRegiones}
                  isDisabled={isLoadingRegiones || helperRegionSucursal.disableRegionSucursal}
                  options={helperRegionSucursal.regionesOptions}
                />
                {messageError.regiones && formik.touched.regiones && <div className="input-feedback">{messageError.regiones}</div>}
              </Label>
            </div>
          </div>
          <div className="col-sm-9">
            <div className="form-group">
              <Label htmlFor="estado" className="col-form-label pt-0 w-100">
                Sucursal
                <LabSelect
                  isMulti
                  id="sucursal"
                  name="sucursal"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={
                    sucursalesOptions && sucursalesOptions.length > 0
                      ? sucursalesOptions.filter((option) => (sucursalValue ? JSON.stringify(sucursalValue).includes(option.value) : ""))
                      : sucursalesToValue.filter((option) => (sucursalValue ? JSON.stringify(sucursalValue).includes(option.value) : ""))
                  }
                  placeholder="Todo"
                  isClearable
                  isLoading={isLoadingCasasCentrales || isLoadingSucursales}
                  isDisabled={isLoadingCasasCentrales || isLoadingSucursales || helperRegionSucursal.disableRegionSucursal || (regionValue && regionValue.length === 0)}
                  options={sucursalesOptions}
                />
              </Label>
            </div>
          </div>
        </div>
        <div className=" mt-3 mb-0 d-flex justify-content-end">
          <Button color="btn-secondary mr-2" onClick={toggle}>
            Cancelar
          </Button>
          <button className="btn btn-success" isLoading={formik.isSubmitting} disabled={formik.isSubmitting} type="submit">
            Guardar
          </button>
        </div>
      </form>
    </>
  );
};

export default SectorGroupForm;
